export { Skeleton as MainSkeleton } from './Skeleton';
